export type ApiBaseUrlEnv = {
  VITE_BASE_URL?: string;
  DEV?: boolean;
  VITE_LOCAL_IP?: string;
};

export function resolveApiBaseURL(env: ApiBaseUrlEnv): string {
  if (env.VITE_BASE_URL) {
    return env.VITE_BASE_URL;
  }

  if (env.DEV && env.VITE_LOCAL_IP) {
    return `http://${env.VITE_LOCAL_IP}:8000/`;
  }

  return "https://api.necta.app/";
}
